<template>
    <div>
        <slot v-bind:scope="sharedScope"></slot>

        <portal to="modals" v-if="liteboxVisible">
            <vue-litebox :items="liteboxItems" :start-at="liteboxStartAt" v-on:close="hideLitebox"></vue-litebox>
        </portal>
    </div>
</template>

<script>
import VueLitebox from './_VueLitebox.vue';
import DATON from '../vendor/DATON.js'

export default {
    name: 'MapBlock',
    components: {
        VueLitebox
    },
    data() {
        let self = this;
        return {
            sharedScope: {
                currentPoiId: null,
                onMarkerClick(id) {
                    self.sharedScope.currentPoiId = id;
                },
                onMapClick() {
                    self.sharedScope.currentPoiId = null;
                },
                onPoiClick(id) {
                    if (self.sharedScope.currentPoiId === id) {
                        self.sharedScope.currentPoiId = null
                    } else {
                        self.sharedScope.currentPoiId = id;
                    }
                }
            },
            selectedIndex: 0,
            liteboxItems: [],
            liteboxStartAt: 0,
            liteboxVisible: false
        }
    },
    mounted() {
        let self = this;

        let data = DATON.parse(self.$el);

        if (data.hasOwnProperty('items')) {
            self.liteboxItems = data.items;
        }

        var elevTrigger = document.getElementsByClassName('elevation-trigger');
        let onStaticClick = (event, pointer, cellElement, cellIndex) => {
            if (event.target) {
                let lnk = event.target.closest('a[data-index]');
                let idx = parseInt(lnk.getAttribute('data-index'));
                self.liteboxStartAt = idx;
                self.liteboxVisible = true;
            }
        }
        if (elevTrigger[0]) {
            elevTrigger[0].addEventListener('click', onStaticClick);
        }
    },
    methods: {
        hideLitebox() {
            this.liteboxVisible = false;
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/js/components/MapBlock.vue